import { DocumentNode } from "graphql";
import { useRecoilValue } from "recoil";
import { userPersonalInfoState } from "../store/user";
import { useModelsSubscription } from "./useModelsModule";

interface SubscriptionForUpdatesProps {
	onCompleted: () => void;
	query: DocumentNode;
}

const SubscriptionForModelsUpdates = ({ onCompleted, query }: SubscriptionForUpdatesProps) => {
	const {
		organization: { externalId },
	} = useRecoilValue(userPersonalInfoState);
	useModelsSubscription(query, {
		onSubscriptionData: ({ subscriptionData: { data } }) => {
			const key = data && Object.keys(data)[0];
			if (key && data[key]?.includes?.(externalId)) onCompleted();
		},
	});

	return null;
};

export default SubscriptionForModelsUpdates;
